// import { COMPONENTS } from "../../lib/constants";

export const QuestStatusBarGrid = {
  size: 100,
  gap: 0,
  name: "QuestStatusBarGrid",
  padding: {
    top: 3,
    bottom: 0,
    left: 5,
    right: 5,
    portrate: {
      top: 3,
      bottom: 3,
      left: 3,
      right: 3,
    },
  },
  main: [
    {
      name: "QuestStatusBarGrid-grid",
      size: 70,
      type: "PortrateGridController",
      config: {
        name: "quest",
        size: 100,
        gap: 0,
        main: [
          {
            name: "empty",
            size: 15.4,
          },
          {
            name: "bg",
            size: 6,
            bounds: {
              width: 576,
              height: 64,
            },
          },
        ],
      },
    },
  ],
  landscape: [
    {
      name: "QuestStatusBarGrid-grid-land",
      size: 65,
      type: "PortrateGridController",
      config: {
        name: "quest",
        size: 100,
        gap: 0,
        main: [
          {
            name: "empty",
            size: 18,
          },
          {
            name: "bg",
            size: 6,
			bounds: {
				width: 576,
				height: 64,
			  },
          },
        ],
      },
    },
  ],
  portrate: [
    {
      name: "QuestStatusBarGrid-grid-port",
      size: 73,
      type: "PortrateGridController",
      config: {
        name: "quest",
        size: 100,
        gap: 0,
        main: [
          {
            name: "empty",
            size: 15,
          },
          {
            name: "bg",
            size: 6,
            bounds: {
              width: 576,
              height: 64,
            },
          },
        ],
      },
    },
  ],
};
